module.exports = __webpack_public_path__ + "static/img/withdrawal.5a708f7a.png";